import React from "react";
import { MOCK_STATS_VENDOR } from "../../data/mock";

const PAYOUTS = [
  { at: "Feb 10, 2026", orders: 5, amount: 12800, status: "Escrow released" },
  { at: "Feb 03, 2026", orders: 7, amount: 18400, status: "Escrow released" },
  { at: "Jan 27, 2026", orders: 4, amount: 9600, status: "Escrow released" },
  { at: "Jan 20, 2026", orders: 6, amount: 15200, status: "Escrow released" },
];

export default function VendorEarnings() {
  return (
    <div data-testid="vendor-earnings">
      <h1 className="font-display text-3xl font-bold">Earnings & Payouts</h1>

      <div className="mt-4 grid gap-4 md:grid-cols-4">
        <Card label="Today" v={`₹${MOCK_STATS_VENDOR.todayEarnings.toLocaleString("en-IN")}`} />
        <Card label="This month" v={`₹${MOCK_STATS_VENDOR.monthEarnings.toLocaleString("en-IN")}`} />
        <Card label="Escrow held" v={`₹${MOCK_STATS_VENDOR.escrowHeld.toLocaleString("en-IN")}`} />
        <Card label="On-time rate" v={`${MOCK_STATS_VENDOR.onTime}%`} />
      </div>

      <div className="mt-6 overflow-hidden rounded-lg border border-neutral-200 bg-white">
        <div className="border-b border-neutral-200 px-5 py-3 text-xs font-semibold uppercase tracking-widest text-neutral-500">Payout history</div>
        <table className="w-full text-sm">
          <thead className="text-xs uppercase tracking-widest text-neutral-500">
            <tr>
              <th className="px-4 py-3 text-left">Date</th>
              <th className="px-4 py-3 text-left">Orders</th>
              <th className="px-4 py-3 text-left">Status</th>
              <th className="px-4 py-3 text-right">Amount</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-neutral-100">
            {PAYOUTS.map((p, i) => (
              <tr key={i} className="hover:bg-neutral-50" data-testid={`ve-payout-${i}`}>
                <td className="px-4 py-3">{p.at}</td>
                <td className="px-4 py-3">{p.orders}</td>
                <td className="px-4 py-3"><span className="rounded-full bg-lime-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-lime-800">{p.status}</span></td>
                <td className="px-4 py-3 text-right font-mono font-bold">₹{p.amount.toLocaleString("en-IN")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Card({ label, v }) {
  return (
    <div className="rounded-lg border border-neutral-200 bg-white p-5">
      <div className="text-xs uppercase tracking-widest text-neutral-500">{label}</div>
      <div className="mt-1 font-display text-3xl font-black">{v}</div>
    </div>
  );
}
